export const TEST_ID = 'pill';
